import { useEffect } from 'react'
import { identifyUser } from '../lib/mixpanel'
import type { User } from '../lib/auth-client'

export function useMixpanelIdentify(user: User | null | undefined): void {
  const id = user?.id
  const email = user?.email
  const name = user?.name ?? null

  useEffect(() => {
    if (!id || !email) return
    identifyUser(id, {
      $email: email,
      ...(name ? { $name: name } : {}),
    })
  }, [id, email, name])
}
